import { render, staticRenderFns } from "./BannerPromocao.vue?vue&type=template&id=7bc04b05"
import script from "./BannerPromocao.vue?vue&type=script&lang=js"
export * from "./BannerPromocao.vue?vue&type=script&lang=js"
import style0 from "./BannerPromocao.vue?vue&type=style&index=0&id=7bc04b05&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports